export interface GameItem {
  id: number;
  name: string;
  description: string;
  imageSeq: string;
  tags: string[];
  popularity: number;
}

export interface CategoryData {
  id: string;
  name: string;
  icon: string;
  description: string;
  items: GameItem[];
}

export const categoriesData: CategoryData[] = [
  {
    id: 'slot-games',
    name: '电子游艺',
    icon: 'ri-gamepad-line',
    description: '汇集全球热门电子游艺游戏，画面精美、玩法多样，从经典水果机到最新3D老虎机，满足各类玩家需求。新用户注册即可使用彩金免费体验。',
    items: [
      {
        id: 101, name: '幸运水果机', description: '经典三消水果机玩法，简单上手，回报丰厚，新手玩家首选推荐。', imageSeq: 'slot-game-fruit-01', tags: ['经典', '新手推荐', '高回报'], popularity: 98,
      },
      {
        id: 102, name: '金龙赐福', description: '中国风主题老虎机，融入传统文化元素，福禄寿喜财五福临门。', imageSeq: 'slot-game-dragon-02', tags: ['中国风', '高奖金', '热门'], popularity: 95,
      },
      {
        id: 103, name: '海洋奇缘', description: '深海探险主题电子游艺，绚丽海底世界画面，多重奖励机制。', imageSeq: 'slot-game-ocean-03', tags: ['3D画面', '免费旋转', '奖池'], popularity: 92,
      },
      {
        id: 104, name: '西部淘金', description: '西部牛仔风格老虎机，狂野的沙漠淘金之旅，奖金翻倍机会多多。', imageSeq: 'slot-game-west-04', tags: ['冒险', '翻倍', '奖池'], popularity: 89,
      },
      {
        id: 105, name: '星际探险', description: '科幻太空主题电子游艺，未来感十足的视觉效果，多重彩金机制。', imageSeq: 'slot-game-space-05', tags: ['科幻', '高倍率', '新上架'], popularity: 87,
      },
      {
        id: 106, name: '翡翠花园', description: '清新自然风格老虎机，唯美花园场景，连消玩法带来持续奖励。', imageSeq: 'slot-game-garden-06', tags: ['清新', '连消', '稳定'], popularity: 85,
      },
    ],
  },
  {
    id: 'table-games',
    name: '棋牌游戏',
    icon: 'ri-stack-line',
    description: '经典棋牌游戏合集，包含斗地主、麻将、德州扑克等热门玩法，真实玩家在线对战，体验竞技乐趣。彩金可直接用于棋牌游戏下注。',
    items: [
      {
        id: 201, name: '欢乐斗地主', description: '最受欢迎的斗地主游戏，支持经典、癞子等多种玩法模式。', imageSeq: 'table-ddz-01', tags: ['经典', '多人', '竞技'], popularity: 97,
      },
      {
        id: 202, name: '四川麻将', description: '地道四川血战到底麻将玩法，真人实时匹配，流畅体验。', imageSeq: 'table-mj-02', tags: ['地方特色', '真人', '热门'], popularity: 94,
      },
      {
        id: 203, name: '德州扑克', description: '专业级德州扑克竞技，多桌锦标赛，与全球玩家一决高下。', imageSeq: 'table-poker-03', tags: ['竞技', '锦标赛', '国际'], popularity: 91,
      },
      {
        id: 204, name: '百人牛牛', description: '经典牛牛玩法升级版，百人同台竞技，紧张刺激的押注体验。', imageSeq: 'table-nn-04', tags: ['多人', '刺激', '高奖金'], popularity: 88,
      },
      {
        id: 205, name: '炸金花', description: '经典炸金花玩法，简单刺激，考验胆识与策略的博弈游戏。', imageSeq: 'table-zjh-05', tags: ['经典', '策略', '博弈'], popularity: 86,
      },
      {
        id: 206, name: '跑得快', description: '快节奏扑克游戏，先出完牌者获胜，考验反应和判断力。', imageSeq: 'table-pkd-06', tags: ['快节奏', '休闲', '竞技'], popularity: 84,
      },
    ],
  },
  {
    id: 'live-casino',
    name: '真人娱乐',
    icon: 'ri-live-line',
    description: '真实赌场直播体验，专业荷官在线发牌，高清实时画面传输，足不出户享受真实赌场氛围。支持多种经典玩法，彩金畅玩无阻。',
    items: [
      {
        id: 301, name: '真人百家乐', description: '最经典的真人娱乐项目，专业美女荷官发牌，多角度高清直播。', imageSeq: 'live-baccarat-01', tags: ['经典', '高清', '真人'], popularity: 99,
      },
      {
        id: 302, name: '真人轮盘', description: '紧张刺激的真人轮盘游戏，多国荷官可选，实时下注体验。', imageSeq: 'live-roulette-02', tags: ['刺激', '国际', '实时'], popularity: 93,
      },
      {
        id: 303, name: '真人龙虎斗', description: '简单明了的龙虎对决，快速开奖，紧张刺激的真人博弈体验。', imageSeq: 'live-dragon-03', tags: ['快速', '简单', '热门'], popularity: 90,
      },
      {
        id: 304, name: '真人骰宝', description: '传统骰宝游戏真人版，多种押注方式，荷官摇骰全程直播。', imageSeq: 'live-sicbo-04', tags: ['传统', '多样', '真人'], popularity: 87,
      },
      {
        id: 305, name: '真人牛牛', description: '真人荷官发牌牛牛，专业级娱乐体验，感受真实的牌桌氛围。', imageSeq: 'live-nn-05', tags: ['专业', '真人', '高奖金'], popularity: 85,
      },
      {
        id: 306, name: '真人三公', description: '经典三公真人版，简单易懂的比牌规则，荷官专业主持。', imageSeq: 'live-sg-06', tags: ['经典', '简单', '真人'], popularity: 83,
      },
    ],
  },
  {
    id: 'sport-betting',
    name: '体育竞技',
    icon: 'ri-football-line',
    description: '全球体育赛事竞猜平台，涵盖足球、篮球、网球等热门项目，实时赔率更新，支持赛中投注。注册彩金可用于体验体育竞猜。',
    items: [
      {
        id: 401, name: '足球竞猜', description: '全球各大联赛全覆盖，英超、西甲、欧冠等热门赛事实时竞猜。', imageSeq: 'sport-football-01', tags: ['全球', '热门', '实时'], popularity: 96,
      },
      {
        id: 402, name: '篮球竞猜', description: 'NBA、CBA等顶级篮球赛事竞猜，多种玩法自由组合。', imageSeq: 'sport-basketball-02', tags: ['NBA', 'CBA', '多样'], popularity: 93,
      },
      {
        id: 403, name: '网球竞猜', description: '四大满贯及ATP赛事全覆盖，实时比分和赔率同步更新。', imageSeq: 'sport-tennis-03', tags: ['大满贯', '实时', '国际'], popularity: 88,
      },
      {
        id: 404, name: '电竞竞猜', description: '英雄联盟、DOTA2等热门电竞赛事竞猜，年轻玩家的最爱。', imageSeq: 'sport-esport-04', tags: ['电竞', '年轻', '潮流'], popularity: 90,
      },
      {
        id: 405, name: '综合赛事', description: '拳击、UFC、高尔夫等综合体育赛事竞猜，满足各类体育迷。', imageSeq: 'sport-mma-05', tags: ['综合', '多样', '国际'], popularity: 82,
      },
      {
        id: 406, name: '虚拟体育', description: '24小时不间断虚拟体育赛事，AI模拟真实比赛，即时开奖。', imageSeq: 'sport-virtual-06', tags: ['24小时', 'AI', '即时'], popularity: 86,
      },
    ],
  },
  {
    id: 'lottery',
    name: '彩票游戏',
    icon: 'ri-ticket-line',
    description: '多种官方彩票游戏在线投注，包含时时彩、快乐8、PK10等热门彩种，开奖结果实时同步。彩金可用于体验各类彩票玩法。',
    items: [
      {
        id: 501, name: '时时彩', description: '高频开奖彩票，每天多期开奖，快速刺激的彩票体验。', imageSeq: 'lottery-ssc-01', tags: ['高频', '快速', '热门'], popularity: 94,
      },
      {
        id: 502, name: '快乐8', description: '选号范围广泛，中奖机会多，每天开奖一次的福利彩票。', imageSeq: 'lottery-kl8-02', tags: ['福利', '高奖金', '每日'], popularity: 91,
      },
      {
        id: 503, name: 'PK10', description: '赛车主题快速开奖彩票，十分钟一期，全天不间断开奖。', imageSeq: 'lottery-pk10-03', tags: ['极速', '高频', '赛车'], popularity: 89,
      },
      {
        id: 504, name: '11选5', description: '简单易懂的高频彩票玩法，11个号码选5个，中奖率高。', imageSeq: 'lottery-11x5-04', tags: ['简单', '高频', '易中奖'], popularity: 87,
      },
      {
        id: 505, name: '六合彩', description: '经典香港六合彩玩法，历史悠久，奖池丰厚吸引力十足。', imageSeq: 'lottery-mark6-05', tags: ['经典', '高奖池', '历史'], popularity: 90,
      },
      {
        id: 506, name: '3D福彩', description: '三位数选号彩票，每天开奖，简单直观的彩票玩法。', imageSeq: 'lottery-3d-06', tags: ['简单', '每日', '稳定'], popularity: 85,
      },
    ],
  },
];

export const allCategories = categoriesData.map((cat) => ({
  id: cat.id,
  name: cat.name,
  icon: cat.icon,
  description: cat.description,
}));